class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    // Delegated on the (persistent) cart-drawer element because the checkout
    // button is re-rendered on every cart update.
    this.addEventListener('click', (evt) => {
      const checkoutBtn = evt.target.closest('#CartDrawer-Checkout');
      if (checkoutBtn) this.pushBeginCheckoutDataLayer(evt, checkoutBtn);
    });
  }

  // Fires a GA4 `begin_checkout` event when the customer proceeds to checkout
  // from the cart drawer. purchase_type is 'subscription' if any cart line has
  // a selling plan, otherwise 'one_time'. Checkout navigation is never blocked
  // for more than the safety timeout, even if /cart.js is slow or fails.
  pushBeginCheckoutDataLayer(evt, checkoutBtn) {
    if (checkoutBtn.dataset.beginCheckoutFired === 'true') return;
    evt.preventDefault();
    checkoutBtn.dataset.beginCheckoutFired = 'true';

    const form = checkoutBtn.form || document.getElementById('CartDrawer-Form');
    let done = false;
    const proceed = () => {
      if (done) return;
      done = true;
      if (form && typeof form.requestSubmit === 'function') form.requestSubmit(checkoutBtn);
      else if (form) form.submit();
    };
    const timer = setTimeout(proceed, 1200);

    const cartUrl = (typeof routes !== 'undefined' && routes.cart_url) || '/cart';
    fetch(`${cartUrl}.js`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then((res) => res.json())
      .then((cart) => {
        const hasSubscription = (cart.items || []).some((line) => line.selling_plan_allocation);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null }); // limpa o objeto anterior antes de empurrar um novo (recomendação GA4/GTM)
        window.dataLayer.push({
          event: 'begin_checkout',
          purchase_type: hasSubscription ? 'subscription' : 'one_time',
        });
      })
      .catch(() => {})
      .finally(() => {
        clearTimeout(timer);
        proceed();
      });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    //invoke coupon discount function
    setTimeout(() => {
      ShopifyAPI
      window.discountCodesFunction()
    }, 800);
    

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
